import React from "react";
var __jsx = React.createElement;
import isNil from 'lodash/isNil';
import { FormattedMessage } from 'react-intl';
import Loader from 'components/common/Loader';
import { Container, IconWrapper, Image, ImageWrapper, Item, SubTitle, TextWrapper, Title } from './SearchItemList.style';
var defaultFieldsMapping = {
  id: 'id',
  label: 'label',
  subLabel: 'subLabel',
  previewImage: 'previewImage'
};

var SearchItemList = function SearchItemList(_ref) {
  var _ref$searchText = _ref.searchText,
      searchText = _ref$searchText === void 0 ? '' : _ref$searchText,
      searchItems = _ref.searchItems,
      _ref$fieldsMapping = _ref.fieldsMapping,
      fieldsMapping = _ref$fieldsMapping === void 0 ? defaultFieldsMapping : _ref$fieldsMapping,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      HoverIcon = _ref.HoverIcon,
      _onClick = _ref.onClick;

  var resultItem = function resultItem(searchItem) {
    return __jsx(Item, {
      key: searchItem[fieldsMapping.id],
      onClick: function onClick() {
        return _onClick(searchItem);
      }
    }, !isNil(searchItem[fieldsMapping.previewImage]) && __jsx(ImageWrapper, null, __jsx(Image, {
      src: searchItem[fieldsMapping.previewImage],
      alt: searchItem[fieldsMapping.label]
    }), HoverIcon && __jsx(IconWrapper, null, __jsx(HoverIcon, null))), __jsx(TextWrapper, null, __jsx(Title, null, searchItem[fieldsMapping.label]), !isNil(searchItem[fieldsMapping.subLabel]) && __jsx(SubTitle, null, searchItem[fieldsMapping.subLabel])));
  };

  return __jsx(Container, null, loading ? __jsx(Loader, null) : __jsx(React.Fragment, null, searchItems.length ? searchItems.map(function (searchItem) {
    return resultItem(searchItem);
  }) : __jsx(React.Fragment, null, searchText.length > 0 && __jsx(FormattedMessage, {
    id: "search-item-list.not-found"
  }))));
};

export default SearchItemList;